<template>
	<div>
		<h1>Cancel order {{ getOrderId }}</h1>

		<div class="margin-top">
			<MaterialToggle v-model="cancel_subscription" label="Cancel subscription" />
		</div>

		<div class="text-right">
			<div style="display: inline-block" class="small-margin-right"><h4>Yes</h4></div>
			<div style="display: inline-block"><h4>No</h4></div>
		</div>

		<div style="display: flex; justify-content: space-between; align-items: center" class="">
			<div><h3>Shall the order be cancelled</h3></div>
			<div>
				<div style="display: inline-block" class="small-margin-right">
					<input type="radio" id="isCancelTrue" :value=true v-model="form.cancel" />
				</div>
				<div style="display: inline-block">
					<input type="radio" id="isCancelFalse" :value=false v-model="form.cancel" />
				</div>
			</div>
		</div>

		<div style="display: flex; justify-content: space-between; align-items: center" class="">
			<div><h3>Shall the customer have refunded her money</h3></div>
			<div>
				<div style="display: inline-block" class="small-margin-right">
					<input :disabled="isDisableNoRefund" type="radio" id="isRefundTrue" :value=true v-model="form.refund" />
				</div>
				<div style="display: inline-block">
					<input :disabled="isDisableNoRefund" type="radio" id="isRefundFalse" :value=false v-model="form.refund" />
				</div>
			</div>
		</div>

		<div style="display: flex; justify-content: space-between; align-items: center" class="">
			<div><h3>Cancel upcoming call (if it exists)</h3></div>
			<div>
				<div style="display: inline-block" class="small-margin-right">
					<input type="radio" id="isRefundTrue" :value=true v-model="form.cancel_call" />
				</div>
				<div style="display: inline-block">
					<input type="radio" id="isRefundFalse" :value=false v-model="form.cancel_call" />
				</div>
			</div>
		</div>

		<div>
			<InputRow label="Cancellation reason">
				<div style="width: 85%;"><select class="full-width" name="reason" id="reason" v-model="form.reason">
					<option :value="''" v-text="'<Select>'"></option>
					<option v-for="reason in cancellationReasons" :value="reason" v-text="reason.reason"></option>
				</select>
					<input v-if="showOtherReasonInput" class="full-width small-margin-top"
								 type="text" v-model="form.reasonText"
								 placeholder="Other reason of cancellation"/>
					<div v-if="showReasonMessage" class="error">Required field</div>
				</div>
			</InputRow>
		</div>

		<div class="small-margin-top small-padding-top border-top text-center">
			<button class="small-margin-right" v-on:click="toggleCancelModal()">Close</button>
			<button :disabled="!isDisabledSendButton || this.cancelProcessing" v-on:click="sendCancelOrder()">Confirm</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'

export default {
  props: {
    order: {
      type: Object
    },

    order_status: {
      type: String,
      default: ''
    },

    id: {
      type: Number
    }
  },
  watch: {
    cancel_subscription () {
      var stdText = 'Cancelling subscription'

      if (!this.form.reason && this.cancel_subscription) {
        this.form.reason = stdText
      } else if (!this.cancel_subscription && this.form.reason == stdText) {
        this.form.reason = ''
      }
    }
  },
  data: () => ({
    cancel_subscription: false,
    showReasonMessage: false,
    comment: '',
    saving: false,
    cancelProcessing: false,
    showCancelModal: false,
    cancellationReasons: [],
    orderTypeId: null,
    form: {
      cancel: '',
      refund: true,
      reason: '',
      reasonText: '',
      cancel_call: true
    }
  }),

  created () {
    this.getCurrentOrder()
  },

  computed: {
    isDisabledSendButton () {
      return (this.form.cancel !== '' && this.form.cancel !== '') || this.cancelProcessing
    },

    isDisableNoRefund () {
      return !this.shouldRefundMoney()
    },

    getOrderId () {
      return this.order.id
    },

    getOrderStatus () {
      return this.order_status ? this.order_status : this.order.status
    },

    showOtherReasonInput () {
      return this.form.reason.reason !== undefined && this.form.reason.reason === 'Other'
    }
  },
  methods: {
    shouldRefundMoney () {
      return true
    },

    getCurrentOrder () {
      Vue.$api.get('/order/' + this.getOrderId, {}, {
        before: () => this.cancelProcessing = true,
        always: () => this.cancelProcessing = false,
        callback: (data) => {
          this.orderTypeId = data.shop_order.order_type_id
          this.cancelProcessing = false
          this.getCancellationReasons()
        }
      })
    },

    getCancellationReasons () {
      Vue.$api.get('/orders/cancellation-reasons', {}, {
        before: () => this.cancelProcessing = true,
        always: () => this.cancelProcessing = false,
        callback: (data) => {
          const orderTypeId = this.orderTypeId
          this.cancellationReasons = _.filter(data, (reason) => {
            return reason.order_type_id == orderTypeId
          })
          this.cancelProcessing = false
        }
      })
    },

    sendCancelOrder () {
      if (this.form.reason.id === undefined ||
						(this.form.reason.reason === 'Other' && _.isEmpty(this.form.reasonText))
      ) {
        this.showReasonMessage = true
        return
      }
      Vue.$api.post('/order/' + this.getOrderId + '/cancel', {
        cancel: this.form.cancel,
        refund: this.form.refund,
        reasonId: this.form.reason.id,
        reason: !_.isEmpty(this.form.reasonText) ? this.form.reasonText : this.form.reason.reason,
        cancel_subscription: this.cancel_subscription,
        cancel_call: this.form.cancel_call
      }, {
        before: () => this.cancelProcessing = true,
        always: () => this.cancelProcessing = false,
        callback: () => {
          this.$emit('success')
          this.load()
        },
        error: (err) => {
          if (err.data && err.data.message) {
            alert(err.data.message)
          }
        }
      })
    },
    toggleCancelModal () {
      this.$emit('closeModal')
    }
  }
}
</script>
<style lang="less" scoped>
	.has-error {
		border-color: #FE0006;
	}

</style>
